{
  "pageTitle": "الجوانب الأكاديمية",
  "leadershipFocused": "تعليم ذو مستوى عالمي",
  "WorldClassEducation": "يركز على القيادة",
  "heroSectionDescription": "في منارة، يُعتبر التميز الأكاديمي جوهر مهمتنا. يشارك الطلاب بفاعلية في الفصول الدراسية، ويتحملون مسؤولية تعلمهم ويسعون لتحقيق مستويات عالية من الإنجاز. صُمّم منهجنا بعناية لتعزيز المهارات التنفيذية مثل التحليل والتنظيم والتفكير المستقل، وهي صفات أساسية للنجاح الجامعي والمواطنة المسؤولة. وبإرشاد هيئة تدريس ملتزمة، يواصل الطلاب السعي نحو التميز وينمون ليصبحوا أفرادًا متفكرين وذوي قيم راسخة.",
  "manaraPortrait": "بورتريه",
  "ofGraduate": "الخريج",
  "whatDoesOur": "ماذا تقدم",
  "studentCentered": "ماذا تقدم مناهجنا المتمركزة",
  "curriculum": "حول الطالب؟",
  "pursueYourPassionTitle1": "اكتشف",
  "pursueYourPassionTitle2": "شغفك مع",
  "pursueYourPassionTitle3": "X-Term",
  "coursesCatalogError": "فشل في الحصول على كتالوج الدورات التدريبية",
  "quarter": "الربع",
  "upcomingEvents": "الأحداث القادمة",
  "pastEvents": "الأحداث الماضية",
  "noUpcomingEvents": "لا توجد أحداث قادمة",
  "noPastEvents": "لا توجد أحداث سابقة"
}
